import { useState } from "react";
import Icon from "../Icon";
import { Avatar, ModalFt } from "../Atoms";
import { esAdmin, esSuper, nombreRol } from "../../utils";

export default function MembersForm({allUsers=[],team,onSave,onClose,inS,lbS}) {
  const [sel,setSel]=useState(()=>new Set((team.members||[]).map(String)));
  const [q,  setQ  ]=useState("");

  const activeUsers = allUsers.filter(u=>u.active!==false);
  const ql = q.trim().toLowerCase();
  const filtered = ql
    ? activeUsers.filter(u=>u.name.toLowerCase().includes(ql)||(u.email||"").toLowerCase().includes(ql))
    : activeUsers;

  const toggle = (id) => setSel(prev=>{
    const n=new Set(prev); const k=String(id);
    n.has(k)?n.delete(k):n.add(k);
    return n;
  });

  return (
    <div>
      <h3 style={{margin:"0 0 4px",fontWeight:700,fontSize:16,display:"flex",alignItems:"center",gap:8}}>
        <Icon name="people-fill" size={15} color="var(--accent)"/>Miembros de "{team.name}"
      </h3>
      <div style={{fontSize:12,color:"var(--text3)",marginBottom:14}}>{sel.size} seleccionado{sel.size!==1?"s":""} de {activeUsers.length}</div>

      {/* Buscador */}
      <div style={{position:"relative",marginBottom:12}}>
        <Icon name="search" size={12} color="var(--text3)" style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)"}}/>
        <input aria-label="Buscar por nombre o email" autoFocus value={q} onChange={e=>setQ(e.target.value)} placeholder="Buscar por nombre o email…"
          style={{...inS,paddingLeft:32,marginBottom:0}}/>
      </div>

      {/* Listado multiselección */}
      <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:14,maxHeight:320,overflowY:"auto"}}>
        {filtered.map(u=>{
          const checked=sel.has(String(u.id));
          return (
            <label key={u.id} style={{display:"flex",alignItems:"center",gap:9,padding:"7px 10px",background:checked?"#f0f9ff":"var(--bg)",borderRadius:8,border:`1px solid ${checked?"#bae6fd":"var(--border)"}`,cursor:"pointer",transition:"all .12s"}}>
              <input type="checkbox" checked={checked} onChange={()=>toggle(u.id)} style={{accentColor:"var(--accent)"}}/>
              <Avatar name={u.name} color={team.color} size={26}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.name}</div>
                <div style={{fontSize:10,color:"var(--text3)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.email}</div>
              </div>
              {esAdmin(u)&&<span title={nombreRol(u.role)} style={{fontSize:10,padding:"2px 6px",borderRadius:20,background:"var(--warn-bg)",color:"var(--warn-text)",fontWeight:700}}>{esSuper(u)?"Super":"Admin"}</span>}
            </label>
          );
        })}
        {filtered.length===0&&(
          <div style={{textAlign:"center",fontSize:12,color:"var(--text3)",padding:"18px 0"}}>Sin resultados para "{q}"</div>
        )}
      </div>

      <ModalFt onClose={onClose} label="Guardar miembros" onSave={()=>onSave([...sel])}/>
    </div>
  );
}
